<template lang="pug">
  header
    .inner
      router-link(to="/")
        img(src="@/assets/logo.png")
      app-nav

</template>
<script>
import AppNav from '@/components/AppNav.vue'
export default {
  name: 'AppHeader',
  components:{
    AppNav,
    }
};
</script>
<style lang="scss" scoped>
  header {
    display: block;
    background:rgb(26, 26, 26);
    color: white;
    width: 100;

    .inner {
      position: relative;

      img{
        padding: 10px;
        height: 100px;
      }
    }
  }
</style>

